import { isEqual } from 'lodash';
import React from 'react';
import CustomSelect from '../../../components/forms/CustomSelect';
import CustomTextDelayInput from '../../../components/forms/CustomTextDelayInput';
import DateField from '../../../components/forms/DateField';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';
import useCompanies from '../../../hooks/api-calls/useCompanies';
import useRoles from '../../../hooks/api-calls/useRoles';
import { FilterOptions } from '../../../hooks/useFilters';


interface ClientsFiltersProps {
    updateFilters: (filters: any) => void;
    filters: any;
}

const ClientsFilters: React.FC<ClientsFiltersProps> = ({ filters, updateFilters }) => {

    // HOOKS

    const { userCan } = usePrivilege();
    const { getRolesList } = useRoles();
    const { getCompaniesList } = useCompanies();

    // RENDER

    return (
        <>
            <DateField
                isClearable
                className="w-full"
                label="Fechas de creación"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.created_at?.from ? new Date(filters.filter_filters.created_at.from) : null}
                endDate={filters.filter_filters?.created_at?.to ? new Date(filters.filter_filters.created_at.to) : null}
                onChange={(date: any) => {
                    const filters_created_at = filters.filter_filters?.created_at;
                    const created_at = date ? { from: date[0], to: date[1] } : null;

                    if (created_at && !isEqual(filters_created_at, created_at)) {
                        updateFilters({ created_at });
                    } else if (!created_at && filters_created_at) {
                        updateFilters({ created_at: null });
                    }
                }}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de actualización"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.updated_at?.from ? new Date(filters.filter_filters.updated_at.from) : null}
                endDate={filters.filter_filters?.updated_at?.to ? new Date(filters.filter_filters.updated_at.to) : null}
                onChange={(date: any) => {
                    const filters_updated_at = filters.filter_filters?.updated_at;
                    const updated_at = date ? { from: date[0], to: date[1] } : null;

                    if (updated_at && !isEqual(filters_updated_at, updated_at)) {
                        updateFilters({ updated_at });
                    }
                    else if (!updated_at && filters_updated_at) {
                        updateFilters({ updated_at: null });
                    }
                }}
            />

            {userCan('list', 'company') && (
                <CustomSelect
                    isSearchable
                    id="company"
                    label="Compañía"
                    options={getCompaniesList()}
                    value={getCompaniesList().find((item: any) => item.value === filters.filter_filters?.company) ?? { label: 'Todas', value: 'null' }}
                    onChange={(e: any) => {
                        if (e.value === 'null') {
                            updateFilters({ company: null });
                            return;
                        }
                        updateFilters({ company: e.value });
                    }}
                />
            )}

        </>
    );
};

export default ClientsFilters;